import React from 'react';
import { Facebook, Instagram, Linkedin } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();

  const goTo = (anchor) => {
    navigate('/');
    setTimeout(() => {
      const el = document.getElementById(anchor);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  return (
    <footer className="footer-welly">
      <div className="footer-inner">

        {/* Logo seul à gauche */}
        <div className="footer-logo-col">
          <Link to="/" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            <img src="/assets/icons/logo-variant.svg" alt="Wellywork" className="footer-logo-img" />
          </Link>
        </div>

        {/* Informations */}
        <div className="footer-col">
          <h4 className="footer-col-title">Informations</h4>
          <ul className="footer-col-list">
            <li className="footer-col-item">
              <img src="/assets/icons/location.svg" alt="" className="footer-col-icon" />
              <span>Dakar, Sénégal</span>
            </li>
            <li className="footer-col-item">
              <img src="/assets/icons/building.svg" alt="" className="footer-col-icon" />
              <span>Cité Mbakiyou Faye, Mamelles - Dakar</span>
            </li>
            <li className="footer-col-item">
              <img src="/assets/icons/mail.svg" alt="" className="footer-col-icon" />
              <span>contact@wellywork.com</span>
            </li>
            <li className="footer-col-item">
              <img src="/assets/icons/call.svg" alt="" className="footer-col-icon" />
              <span>+221 76 151 39 12</span>
            </li>
          </ul>
        </div>

        {/* Welly */}
        <div className="footer-col">
          <h4 className="footer-col-title">Welly</h4>
          <ul className="footer-col-list">
            <li><button onClick={() => goTo('partenaires')} className="footer-col-link">Commerces partenaires <span className="footer-arrow">›</span></button></li>
            <li><button onClick={() => goTo('confiance')}   className="footer-col-link">Entreprises partenaires <span className="footer-arrow">›</span></button></li>
            <li><button onClick={() => goTo('témoignages')} className="footer-col-link">Témoignages <span className="footer-arrow">›</span></button></li>
            <li><Link to="/actualites" className="footer-col-link">Actualités <span className="footer-arrow">›</span></Link></li>
          </ul>
        </div>

        {/* Solutions */}
        <div className="footer-col">
          <h4 className="footer-col-title">Solutions</h4>
          <ul className="footer-col-list">
            <li><button onClick={() => goTo('commercants')}  className="footer-col-link">Pour les commerçants <span className="footer-arrow">›</span></button></li>
            <li><button onClick={() => goTo('entreprises')}  className="footer-col-link">Pour les entreprises <span className="footer-arrow">›</span></button></li>
            <li><button onClick={() => goTo('particuliers')} className="footer-col-link">Pour les particuliers <span className="footer-arrow">›</span></button></li>
          </ul>
        </div>

        {/* Suivre */}
        <div className="footer-col">
          <h4 className="footer-col-title">Suivre</h4>
          <div className="footer-social-row">
            <a href="https://www.facebook.com/wellyworkofficiel/?locale=fr_FR" target="_blank" rel="noopener noreferrer" className="footer-social-btn"><Facebook size={18} /></a>
            <a href="https://fr.linkedin.com/company/wellywork?trk=public_profile_experience-item_profile-section-card_image-click" target="_blank" rel="noopener noreferrer" className="footer-social-btn"><Linkedin size={18} /></a>
            <a href="https://www.instagram.com/welly.work/" target="_blank" rel="noopener noreferrer" className="footer-social-btn"><Instagram size={18} /></a>
          </div>
          <div className="footer-apps-row">
            <a href="https://apps.apple.com/us/app/welly/id6738099419" target="_blank" rel="noopener noreferrer" className="footer-app-btn">
              <img src="/assets/icons/apple.svg" alt="" className="footer-app-icon" />
              <span>IOS</span>
            </a>
            <div className="footer-app-divider" />
            <a href="https://play.google.com/store/apps/details?id=com.wellyworkentreprise.wellywork.app.customer&hl=ln" target="_blank" rel="noopener noreferrer" className="footer-app-btn">
              <img src="/assets/icons/android.svg" alt="" className="footer-app-icon" />
              <span>Android</span>
            </a>
          </div>
        </div>

      </div>

      <div className="footer-bottom">
        <p>Copyright © 2026 wellywork | Tous droits réservés | <Link to="/cgu" style={{color:'rgba(255,255,255,0.6)', textDecoration:'none'}}>Conditions Générales d'Utilisation</Link> | <Link to="/politique-confidentialite" style={{color:'rgba(255,255,255,0.6)', textDecoration:'none'}}>Politique de Confidentialité</Link></p>
      </div>
    </footer>
  );
};

export default Footer;
